import moment from 'moment'

export const customerComplaintCorrective = {
  id: '',
  complaintNo: '',
  customerComplaintId: '',
  actionNo: '',
  rootCauseType: '',
  rootCauseRemark: '',
  actionType: '',
  actionRemark: '',
  picId: '',
  picName: '',
  picEmail: '',
  workDescription: '',
  isRevision: 0,
  evidence: '',
  item: '',
  remark: '',
  targetDate: moment().format('YYYY-MM-DD'),
}

export const customerComplaintCorrectiveDetail = {
  id: '',
  correctiveInternalId: '',
  complaintNo: '',
  type: '',
  isRevision: '',
  workDescription: '',
  evidence: '',
  completionDate: moment().format('YYYY-MM-DD'),
  createdBy: '',
  updatedBy: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaintDetail = {
  customerComplaintId: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
}

export const customerComplaintCorrectiveInternal = {
  id: '',
  correctiveActionNumber: '',
  customerComplaintId: '',
  rootCause: '',
  corrective: '',
  correctivePicId: '',
  correctiveTargetDate: moment().format('YYYY-MM-DD'),
  preventive: '',
  preventivePicId: '',
  preventiveTargetDate: moment().format('YYYY-MM-DD'),
}